<template>
  <div class="page-content prose">
    <div class="container">
      <h1>Informatie over makelaars</h1>
      <p>
        Wilt u uw huis verkopen of bent u op zoek naar een ander (huur)huis? Dan
        is het raadzaam een deskundige in te schakelen die u optimaal kan
        begeleiden bij de koop of verkoop of de huur van een nieuw huis. Door
        makelaars te vergelijken is het mogelijk om de beste makelaar te vinden
        die qua service en kosten volledig past bij uw wensen en eisen. Door
        makelaars onderling te vergelijken weet u direct wat u kunt verwachten
        aan makelaarskosten en komt u bovendien niet voor ongewenste
        verrassingen te staan.
      </p>
      <iframe
        class="my-4"
        src="https://www.youtube.com/embed/KcfyXrIQMX8"
        frameborder="0"
        width="100%"
        height="315"
        style="max-width: 560px"
      />

      <h2>Wat doet een makelaar</h2>
      <p>
        Een makelaar is opgeleid om mensen te begeleiden bij de koop, verkoop,
        verhuur of het huren van een huis of bedrijfspand. De makelaar heeft
        daarbij tot taak om het gehele proces te begeleiden. Indien gewenst kan
        de makelaar specifiek op zoek gaan naar geschikte woon- of
        bedrijfsruimte, er kan een taxatie gedaan worden en de makelaar kan
        advies uitbrengen omtrent de af te sluiten hypotheek. Daarnaast is de
        makelaar ook bevoegd om zich bezig te houden met de bemiddeling van
        commercieel vastgoed. Een andere taak die eveneens door een makelaar
        vervuld kan worden is die van adviseur voor de gemeente en
        woningbouwvereniging. De makelaar is bevoegd om advies te geven omtrent
        nieuwbouw, renovatie, onteigening en verbouwing.
      </p>

      <h2>Makelaar vergelijken</h2>
      <p>
        Het is raadzaam om de verschillende diensten van makelaars te
        vergelijken. Niet elke makelaar hanteert dezelfde service. Bij het
        vergelijken van makelaars is het handig om niet alleen naar de
        verschillen in prijs en eventueel de aangeboden diensten te kijken, maar
        ook ervaringen van anderen kunnen van cruciaal belang zijn om de juiste
        keuze te kunnen maken. Het vergelijken kan in alle rust thuis of op
        kantoor gebeuren, waarbij via diverse opties de beste makelaar voor uw
        situatie gevonden kan worden.
      </p>

      <h2>Kosten makelaar</h2>
      <p>
        Een makelaar is bevoegd zelfstandig te werken, maar kan ook in
        loondienst zijn van een makelaarskantoor. Ongeacht of de makelaar
        zelfstandig is of in dienstverband werkzaam, aan het inschakelen van een
        makelaar zijn kosten verbonden. De kosten van een makelaar bestaan uit
        een bepaald percentage van de koop- of huurprijs. In veel gevallen zijn
        de makelaarskosten echter ook onderhandelbaar. De kosten worden alleen
        in rekening gebracht indien de koop of verkoop daadwerkelijk plaats
        heeft gevonden. Eventueel bijkomende kosten kunnen bestaan uit
        advertentiekosten.
      </p>

      <p>
        De voordeligste makelaar in uw regio vind en vergelijkt u via de gratis
        offertetool op deze pagina. Vul uw postcode in en vraag
        <nuxt-link to="/"> gratis vrijblijvende offertes </nuxt-link> aan van
        makelaars in uw regio.
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'

export default {
  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Op zoek naar een makelaar?',
      headDescription:
        'Binnenkort je huis verkopen? Door makelaars te vergelijken is het mogelijk om de beste makelaar te vinden die qua service en kosten volledig bij je past.',
      path: '/informatie-over-makelaars',
    }
  },
}
</script>
